"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectedPlanType = void 0;
var SelectedPlanType;
(function (SelectedPlanType) {
    SelectedPlanType["DEFAULT"] = "attIconCheck";
    SelectedPlanType["DTVNOW_BASE_OFFER"] = "attIconTvOff";
    SelectedPlanType["ATT_ICON_TV"] = "attIconTv";
    SelectedPlanType["CHANGEPLAN_UNLIMITED_OFFER"] = "attIconMobiletower";
    SelectedPlanType["ACCESSORY_PANEL"] = "attIconDevicesAccessories";
    SelectedPlanType["DEVICE_PANEL"] = "attIconMobilesmartphone";
    SelectedPlanType["DTV_SATALITE_WHITE"] = "attIconDtvsatellite";
    SelectedPlanType["DTV_INTERNATIONAL_PACKAGE"] = "attIconLocations";
    SelectedPlanType["DTV_GLOBAL_NETWORK"] = "attIconGlobalInternet";
})(SelectedPlanType = exports.SelectedPlanType || (exports.SelectedPlanType = {}));
//# sourceMappingURL=SelectedPlanProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/panels/SelectedPlan/SelectedPlanProps.js
// module id = 820
// module chunks = 8